import React from "react";
import "./index.less";
import cx from "classnames";

export const LOADER_COLOR = "#033967";

/** Loader function */
export default function Loader({
  loading,
}) {
  return (
    <div className={cx("sweet-loading", !loading && "hide")}>
      <div className={"loader-inner"} />

      <div className={"loader-bg"} />
    </div>
  );
}
